var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-page"},[_c('img',{attrs:{"src":require("../assets/face logo.png")}}),_c('user-register',{attrs:{"phone":_vm.phone},on:{"userRegistered":_vm.onUserRegistered}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }